<template>
  <div class="trade-history">
    <template v-if="validatedTrades.length">
      <div class="text_large">{{ i18n.trd_history() }}</div>
      <md-table class="trade-history__table scrollbar">
        <md-table-row>
          <md-table-head>{{ i18n.trd_history_amount({ asset: assets.base }) }}</md-table-head>
          <md-table-head>{{ i18n.trd_history_price({ asset: assets.quote }) }}</md-table-head>
          <md-table-head>{{ i18n.trd_history_total({ asset: assets.quote }) }}</md-table-head>
          <md-table-head>{{ i18n.trd_history_time() }}</md-table-head>
        </md-table-row>

        <md-table-row v-for="(item, i) in validatedTrades"
                      :key="`${i}-trade-history-item`"
                      :class="`trade-history__item-status--${item.priceStatus}`">
          <template v-if="i < maxLengthOfTradeHistory">
            <md-table-cell class="text_large">{{ roundCurrency(item.baseAmount, assets.base) }}</md-table-cell>
            <md-table-cell class="trade-history__item-price text_large">
              {{ roundCurrency(item.price, assets.quote) }}
              <template v-if="item.priceStatus === 0">
                <md-icon>call_received</md-icon>
              </template>
              <template v-if="item.priceStatus === 1">
                <md-icon>call_made</md-icon>
              </template>
            </md-table-cell>
            <md-table-cell class="trade-history__item-total text_large">{{ roundCurrency(multiply(item.baseAmount, item.price), assets.quote) }}</md-table-cell>
            <md-table-cell class="trade-history__item-date text_large">{{ toValidDate(item.createdAt) }}</md-table-cell>
          </template>
        </md-table-row>
      </md-table>
    </template>
    <template v-else>
      <div class="container__no-data">
        <md-icon class="md-size-4x">trending_up</md-icon>
        <div class="text_large">{{ i18n.trd_no_trade_history() }}</div>
        <div class="text_description text_margin text_medium">{{ i18n.trd_here_will_be_the_list() }}</div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import { multiply } from '@utils/math.util'
  import CurrencyRound from '@com/mixins/currency.round.mixin'

  export default {
    name: 'trade-history',
    mixins: [CurrencyRound],
    props: {
      assets: { type: Object, require: true }
    },
    data () {
      return {
        maxLengthOfTradeHistory: 10,
        i18n,
        multiply
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.trades
      ]),
      validatedTrades () {
        // priceStatus:
        // 0 === price decreased
        // 1 === price increased
        // 2 === price hasn't changed
        let trades = this.trades.reverse()
        for (let item of trades) {
          let index = trades.indexOf(item)
          if (trades.length) {
            trades['0'].priceStatus = 2
          }
          if (trades[index] !== trades['0']) {
            let prevIndex = index - 1
            if (Number(trades[index].price) > Number(trades[prevIndex].price)) {
              trades[index].priceStatus = 1
            } else if (Number(trades[index].price) === Number(trades[prevIndex].price)) {
              trades[index].priceStatus = 2
            } else {
              trades[index].priceStatus = 0
            }
          }
        }
        return trades.reverse()
      }
    },
    methods: {
      toValidDate (date) {
        return new Date(date).toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true
        })
      }
    },
    watch: {

    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/variables";
  @import "~scss/mixins";

  .trade-history {

    &__table {
      margin-top: 24px;
    }

    &__item-price .md-icon {
      font-size: 14px !important;
    }
  }

  .trade-history__item-price,
  .trade-history__item-total,
  .trade-history__item-price .md-icon,
  .trade-history__item-total .md-icon {
    .trade-history__item-status--1 & {
      color: $green;
    }
    .trade-history__item-status--0 & {
      color: $col-error;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/tradeHistory/Trade.TradeHistory.vue